@if (useProgress$ | async) {
  <sh-progress-label [type]="labelType$ | async" [percentage]="cell.percentage">{{label$ | async}}</sh-progress-label>
} @else {
  <sh-label [type]="labelType$ | async">{{label$ | async}}</sh-label>
}

